import { Button, Grid, Link, Paper, useTheme, Typography } from "@mui/material";
import {
    AccountingBillLine,
    AccountingBillLineHeader,
} from "./AccountingBillLine";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { SearchBox } from "@/common/StyledComponents";
import {
    openLinesPopup,
    searchBillLines,
    selectToAllocateBillLines,
    selectToAllocateLines,
} from "./actualSlice";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { useSelector } from "react-redux";
import { selectOrganizationPublicId } from "@/auth/authSlice";
import SubscriptionComponent from "@/common/SubscriptionComponent";
import AccountingBillUploadPopup from "./AccountingBillUploadPopup";
import ExitToAppRoundedIcon from "@mui/icons-material/ExitToAppRounded";
import useEntitlements from "@/auth/useEntitlements";
import { FEATURE_VENDORS } from "@/constants";

export default function AccountingBillLines({ billLines, selectable }) {
    return (
        <>
            <AccountingBillLineHeader selectable={selectable} />
            {billLines.length > 0 ? (
                <>
                    {billLines.map(
                        (billLine, index) =>
                            billLine.main_bill_id == null && (
                                <AccountingBillLine
                                    key={index}
                                    billId={billLine.id}
                                    selectable={selectable}
                                />
                            ),
                    )}
                </>
            ) : (
                <>
                    <Paper
                        sx={{
                            textAlign: "center",
                            boxShadow: "none",
                            padding: 4,
                        }}
                    >
                        <span style={{ fontSize: 14, color: "gray" }}>
                            No bills here
                        </span>
                    </Paper>
                </>
            )}
        </>
    );
}

export const AccountingBillLinesHeader = ({ getProject }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const { hasFeature } = useEntitlements();
    const organizationPublicId = useSelector(selectOrganizationPublicId);
    const handleSearch = (event) => {
        const value = event.target.value;
        dispatch(searchBillLines(value));
    };
    const checkedBillLines = useSelector((state) =>
        selectToAllocateBillLines(state),
    );
    const hasCheckedBillLines = checkedBillLines.length > 0;
    return (
        <Grid
            container
            justifyContent={"space-between"}
            alignItems={"center"}
            paddingBottom={2}
            position={"sticky"}
            top={-1}
            zIndex={1}
            padding={1}
            sx={{ background: theme.palette.background.default }}
        >
            <Grid item>
                <Typography variant="h2">Bills</Typography>
            </Grid>
            <Grid item>
                <Grid container spacing={2}>
                    {hasFeature(FEATURE_VENDORS) && (
                        <Grid item>
                            <AccountingBillUploadPopup
                                getProject={getProject}
                            />
                        </Grid>
                    )}
                    {hasFeature(FEATURE_VENDORS) && (
                        <Grid item>
                            <Button
                                LinkComponent={"a"}
                                target="_blank"
                                href={`/ap/invoice?public_id=${organizationPublicId}`}
                                variant="contained"
                                startIcon={<ExitToAppRoundedIcon />}
                            >
                                Invoice Portal
                            </Button>
                        </Grid>
                    )}
                    <Grid item>
                        <Button
                            disabled={!hasCheckedBillLines}
                            onClick={() => {
                                dispatch(openLinesPopup());
                            }}
                            variant="contained"
                            startIcon={<EditOutlinedIcon />}
                        >
                            Approve and allocate
                        </Button>
                    </Grid>
                    <Grid item>
                        <SearchBox handleSearch={handleSearch} />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
